export class FlowsheetEventHistory {
    public EmployeeId: string;
    public EventType: string;
    public EventDate: Date;

    constructor(args: Omit<FlowsheetEventHistory, "proptype">) {
        Object.assign(this, args);
    }
}
